import { useCallback, useEffect, useState } from 'react';



const useRequest = ({
	requestFunction,
	lazy = false,
}) => {
	const [ loading, setLoading ] = useState(false);
	const [ hasLoaded, setHasLoaded ] = useState(false);
	const [ error, setError ] = useState(undefined);
	const [ data, setData ] = useState(undefined);

	const fetchData = useCallback(async () => {
		setLoading(true);

		try {
			const result = await requestFunction();
			setData(result);
			setLoading(false);
			setHasLoaded(true);
			setError(undefined);

			return result;
		} catch(err) {
			setError(err);
			setLoading(false);

			return err;
		}
	}, [ requestFunction, setData, setLoading, setHasLoaded ]);

	useEffect(() => {
		if(!lazy) {
			fetchData();
		}

	}, [ fetchData, lazy ]);

	return {
		data,
		loading,
		hasLoaded,
		error,
		refetch: fetchData,
	};
};

export default useRequest;
